import { ReactNode } from 'react';
import { Card } from '@/components/ui/Card';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  isLoading?: boolean;
  isError?: boolean;
  isEmpty?: boolean;
  emptyLabel?: string;
  children: ReactNode;
}

const StateBox = ({ children }: { children: ReactNode }) => (
  <div className="flex h-64 items-center justify-center text-sm text-gray-400 dark:text-gray-500">
    {children}
  </div>
);

export const ChartCard = ({
  title,
  subtitle,
  action,
  isLoading,
  isError,
  isEmpty,
  emptyLabel = 'Aucune donnée',
  children,
}: ChartCardProps) => (
  <Card className="flex flex-col gap-4">
    <div className="flex items-start justify-between gap-4">
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white">{title}</h3>
        {subtitle && <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>}
      </div>
      {action}
    </div>
    {isLoading ? (
      <StateBox>Chargement…</StateBox>
    ) : isError ? (
      <StateBox>Impossible de charger les données</StateBox>
    ) : isEmpty ? (
      <StateBox>{emptyLabel}</StateBox>
    ) : (
      children
    )}
  </Card>
);
